export function clearUrlQuery() {
  window.history.replaceState(
    {},
    document.title,
    window.location.origin + window.location.pathname
  );
}
